import { createFileRoute, Link } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/checkout/return")({
  validateSearch: (search: Record<string, unknown>): { session_id?: string } => ({
    session_id: typeof search.session_id === "string" ? search.session_id : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Pagamento ricevuto — ChefConnect" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: CheckoutReturn,
});

function CheckoutReturn() {
  const { session_id } = Route.useSearch();
  return (
    <section className="container mx-auto max-w-xl px-4 py-24 text-center">
      <CheckCircle2 className="mx-auto h-16 w-16 text-gold" />
      <h1 className="mt-6 font-display text-4xl">Pagamento ricevuto</h1>
      <p className="mt-4 text-muted-foreground">
        Il tuo abbonamento Premium è in attivazione. Riceverai una notifica appena disponibile.
      </p>
      {session_id && (
        <p className="mt-2 text-xs text-muted-foreground">Sessione: {session_id}</p>
      )}
      <div className="mt-8 flex justify-center gap-3">
        <Button asChild className="bg-gold text-gold-foreground hover:bg-gold/90">
          <Link to="/dashboard">Vai alla dashboard</Link>
        </Button>
      </div>
    </section>
  );
}